import { FormFieldError } from "../form-field-error/FormFieldError.js";
import inputs_module_default from "../inputs.module.js";
import { Box, PinInput } from "@mantine/core";
import { useEffect, useRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";

//#region src/components/inputs/pin-input/PinInput.tsx
/**
* A PIN input component for entering codes like OTP, verification codes, etc.
*/
const PinInput$1 = ({ length = 6, type = "number", mask = false, placeholder, value, defaultValue, onChange, onComplete, disabled, autoFocus = false, error, size = "xl", gap = "md", name, form, oneTimeCode = false, inputMode = "numeric", inputType = "number", "data-testid": testId }) => {
	const containerRef = useRef(null);
	const previousValueRef = useRef(value);
	useEffect(() => {
		if (previousValueRef.current && previousValueRef.current.length > 0 && value === "") {
			const firstInput = containerRef.current?.querySelector("input[type=\"tel\"], input[type=\"number\"], input[type=\"text\"]");
			if (firstInput) firstInput.focus();
		}
		previousValueRef.current = value;
	}, [value]);
	const errorMessage = error && typeof error === "string" ? /* @__PURE__ */ jsx(FormFieldError, { errText: error }) : null;
	return /* @__PURE__ */ jsxs(Box, {
		ref: containerRef,
		"data-testid": testId,
		children: [/* @__PURE__ */ jsx(PinInput, {
			length,
			type,
			mask,
			placeholder,
			value,
			defaultValue,
			onChange,
			onComplete,
			disabled,
			autoFocus,
			error: !!error,
			size,
			gap,
			name,
			form,
			oneTimeCode,
			inputMode,
			inputType,
			classNames: inputs_module_default
		}), errorMessage]
	});
};

//#endregion
export { PinInput$1 as PinInput };